var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { api } from "./api.service";
export var obterDadosCondutor = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, dados;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.get("/Condutor?Cpf=".concat(data.cpf), {
                    headers: {
                        "X-Temp-Authorization": "36a78daa1d751b8277e9",
                    },
                })];
            case 1:
                response = _a.sent();
                dados = response.data;
                return [2 /*return*/, dados];
        }
    });
}); };
export var solicitarRenovacaoCnh = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, dados;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.post("/Condutor/ProcessoCnh/Renovacao", data, {
                    headers: {
                        "X-Temp-Authorization": "36a78daa1d751b8277e9",
                    },
                })];
            case 1:
                response = _a.sent();
                dados = response.data;
                return [2 /*return*/, dados];
        }
    });
}); };
export var obterTaxas = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, boletos;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.get("/Condutor/DebitoCondutor?Cpf=".concat(data.cpf), {
                    headers: {
                        "X-Temp-Authorization": "36a78daa1d751b8277e9",
                    },
                })];
            case 1:
                response = _a.sent();
                boletos = response.data;
                return [2 /*return*/, boletos];
        }
    });
}); };
export var solicitarCnhDefinitiva = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, dados;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.post("/Condutor/ProcessoCnh/CnhDefinitiva", data, {
                    headers: {
                        "X-Temp-Authorization": "36a78daa1d751b8277e9",
                    },
                })];
            case 1:
                response = _a.sent();
                dados = response.data;
                return [2 /*return*/, dados];
        }
    });
}); };
export var solicitarSegundoVia = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, dados;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.post("/Condutor/ProcessoCnh/SegundaVia", data, {
                    headers: {
                        "X-Temp-Authorization": "36a78daa1d751b8277e9",
                    },
                })];
            case 1:
                response = _a.sent();
                dados = response.data;
                return [2 /*return*/, dados];
        }
    });
}); };
export var obterFormularioRenach = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, formulario;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.get("Condutor/ProcessoCnh/FormularioRenach?Cpf=".concat(data.cpf, "&NumeroRenach=").concat(data.numeroRenach), {
                    headers: {
                        "X-Temp-Authorization": "36a78daa1d751b8277e9",
                    },
                })];
            case 1:
                response = _a.sent();
                formulario = response.data;
                return [2 /*return*/, formulario];
        }
    });
}); };
export var obterFoto = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, foto;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.get("Condutor/FotoCondutor?Cpf=".concat(data.cpf, "&NumeroRenach=").concat(data.numeroRenach), {
                    headers: {
                        "X-Temp-Authorization": "36a78daa1d751b8277e9",
                    },
                })];
            case 1:
                response = _a.sent();
                foto = response.data;
                return [2 /*return*/, foto];
        }
    });
}); };
export var alterarEndereco = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, dados;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.put("/Condutor/Endereco", data, {
                    headers: {
                        "X-Temp-Authorization": "36a78daa1d751b8277e9",
                    },
                })];
            case 1:
                response = _a.sent();
                dados = response.data;
                return [2 /*return*/, dados];
        }
    });
}); };
export var solicitarPid = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, dados;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.post("/Condutor/ProcessoPid", data, {
                    headers: {
                        "X-Temp-Authorization": "36a78daa1d751b8277e9",
                    },
                })];
            case 1:
                response = _a.sent();
                dados = response.data;
                return [2 /*return*/, dados];
        }
    });
}); };
export var solicitarCertidaoCondutor = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, dados;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.post("/Condutor/CertidaoCondutor", data, {
                    headers: {
                        "X-Temp-Authorization": "36a78daa1d751b8277e9",
                    },
                })];
            case 1:
                response = _a.sent();
                dados = response.data;
                return [2 /*return*/, dados];
        }
    });
}); };
export var obterCertidaoCondutor = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, dados;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.get("/Condutor/CertidaoCondutor?NumeroRegistro=".concat(data.numeroRegistro, "&DataNascimento=").concat(data.dataNascimento), {
                    headers: {
                        "X-Temp-Authorization": "36a78daa1d751b8277e9",
                    },
                })];
            case 1:
                response = _a.sent();
                dados = response.data;
                return [2 /*return*/, dados];
        }
    });
}); };
export var cancelarCertidaoCondutor = function (numeroCertidao) { return __awaiter(void 0, void 0, void 0, function () {
    var response, dados;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.delete("/Condutor/CertidaoCondutor?NumeroCertidao=".concat(numeroCertidao))];
            case 1:
                response = _a.sent();
                dados = response.data;
                return [2 /*return*/, dados];
        }
    });
}); };
